"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ticket_service_1 = require("../../../tickets/ticket.service");
var CustomerReferenceCell = /** @class */ (function () {
    function CustomerReferenceCell(ticketService) {
        this.ticketService = ticketService;
        this.value = '';
    }
    CustomerReferenceCell.prototype.agInit = function (params) {
        this.params = params;
        this.gridApi = params.api;
    };
    CustomerReferenceCell.prototype.ngAfterViewInit = function () { };
    CustomerReferenceCell.prototype.getValue = function () {
        if (this.reference) {
            return this.reference.customerName;
        }
        var cell = this.gridApi.getFocusedCell();
        var row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        return row && row.data.customerName ? row.data.customerName : '';
    };
    CustomerReferenceCell.prototype.isCancelBeforeStart = function () {
        return false;
    };
    CustomerReferenceCell.prototype.isCancelAfterEnd = function () {
        return false;
    };
    CustomerReferenceCell.prototype.isPopup = function () {
        return true;
    };
    CustomerReferenceCell.prototype.onReferenceClicked = function (reference) {
        var _this = this;
        var cell = this.gridApi.getFocusedCell();
        var row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        this.ticketService.updateFieldReference(row.data.id, reference, 'customer').subscribe(function (ticket) {
            _this.reference = reference;
            row.setData(ticket);
            _this.gridApi.stopEditing();
        });
    };
    CustomerReferenceCell.prototype.onReferenceClosed = function () {
        this.gridApi.stopEditing();
    };
    return CustomerReferenceCell;
}());
exports.CustomerReferenceCell = CustomerReferenceCell;
